import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FieldTypeTextSimpleComponent } from '../field-type-text/field-type-text-simple/field-type-text-simple.component';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
  selector: 'app-new-snippet-modal',
  templateUrl: './new-snippet-modal.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective,
    FieldTypeTextSimpleComponent
  ]
})
export class NewSnippetModalComponent {
  list: any = this.dialogConfig.data.list;
  configuration: any = this.dialogConfig.data.configuration;
  snippet: any = this.configuration.snippet;
  shortIdField: any = {
    id: 'short-id',
    required: true,
    maxLength: 20,
    label: this.translate.instant('snippets-reusable.short-id'),
  }
  titleField: any = {
    id: 'descriptive-title',
    required: true,
    maxLength: 100,
    label: this.translate.instant('snippets-reusable.descriptive-title'),
  }

  constructor(
    private translate: AfTranslateFactory,
    private dialogRef: DynamicDialogRef<NewSnippetModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private modalService: ModalServiceService
  ) { }

  itemSelected(newValue: any, field: any, type: string) {
    this.snippet[type] = newValue;
    if (this.snippet[type]) {
      field.error = false;
    }
  }

  saveSnippet() {
    if (!this.hasValidSave()) {
      this.modalService.errorModal({ text: this.translate.instant('snippets-reusable.validation-error') });
      return;
    }

    this.handleAccept(this.snippet);
  }

  hasValidSave(): boolean {
    const shortIdExists = (shortId: string): boolean => {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].shortId === shortId) return true;
      }
      return false;
    }

    let isValid: boolean = true;
    if (!this.snippet.shortId) {
      isValid = false;
      this.shortIdField.error = true;
      delete this.shortIdField['errorText'];
    } else if (shortIdExists(this.snippet.shortId)) {
      isValid = false;
      this.shortIdField.error = true;
      this.shortIdField.errorText = this.translate.instant('snippets-reusable.validation-repeated-id');
    } else {
      this.shortIdField.error = false;
    }
    if (this.snippet.title) {
      this.titleField.error = false;
    } else {
      isValid = false;
      this.titleField.error = true;
    }
    return isValid;
  }

  handleDismiss() {
    this.dialogRef.close({ result: 'cancel' });
  }

  handleAccept(snippet: any) {
    this.dialogRef.close({
      result: 'ok',
      snippet: snippet
    });
  }
}
